'use client'

import {useScrollStore} from '@local/stores/stores'
import {Button, ButtonProps} from '@local/ui/components'
import {offsetTop} from '@local/utils/offset'
import {usePathname} from 'next/navigation'
import {ReactNode, forwardRef} from 'react'

export interface ButtonScrollProps extends ButtonProps {
	/**
	 * `target` is the id to scroll to. It should be the same as the `id` of the element to scroll to.
	 */
	target: string
	children: ReactNode
	scrollToAnchor?: boolean
	offset?: number
}

export const ButtonScroll = forwardRef(
	(
		{
			children,
			target,
			scrollToAnchor = true,
			offset,
			onClick,
			...rest
		}: ButtonScrollProps, ref) => {
		const pathname = usePathname()
		const _href = `${pathname}${target}`
		const scrollTo = useScrollStore(state => state.scrollTo)
		const handleClick = (e) => {
			if (scrollToAnchor) {
				if (offset) {
					scrollTo(offset, {duration: 0.5})
				} else {
					const _target = document.getElementById(target.replace('#', ''))
					if (_target) {
						const _offset = offsetTop(_target) - 80
						scrollTo(_offset, {duration: 0.5})
					}
				}
			}
			if (onClick) onClick(e)
		}
		return (
			<Button {...rest} ref={ref} href={_href} onClick={handleClick}>
				{children}
			</Button>
		)
	},
)
